var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_571_5492",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 30,
    height: 30,
    transform: "rotate(-180 30 30)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_571_5492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9983 10.4443L10.443 14.9996L14.9983 19.5549L16.3036 18.2496L13.9911 15.9371L19.6858 15.9371V14.0621L13.9911 14.0621L16.3036 11.7496L14.9983 10.4443ZM14.9961 3.12458C16.6386 3.12458 18.1825 3.43624 19.6277 4.05958C21.0729 4.68291 22.33 5.52885 23.3989 6.59739C24.4679 7.66593 25.3142 8.92249 25.938 10.3671C26.5615 11.8117 26.8733 13.3551 26.8733 14.9974C26.8733 16.6399 26.5616 18.1837 25.9383 19.6289C25.315 21.0742 24.469 22.3312 23.4005 23.4002C22.3319 24.4692 21.0754 25.3155 19.6308 25.9393C18.1862 26.5628 16.6428 26.8746 15.0005 26.8746C13.358 26.8746 11.8141 26.5629 10.3689 25.9396C8.92371 25.3162 7.66663 24.4703 6.59767 23.4018C5.52871 22.3332 4.68236 21.0767 4.05861 19.6321C3.43506 18.1875 3.12329 16.6441 3.12329 15.0018C3.12329 13.3593 3.43496 11.8154 4.05829 10.3702C4.68163 8.92499 5.52757 7.66791 6.59611 6.59895C7.66465 5.52999 8.92121 4.68364 10.3658 4.05989C11.8104 3.43635 13.3538 3.12458 14.9961 3.12458ZM14.9983 4.99958C12.2066 4.99958 9.84204 5.96833 7.90454 7.90583C5.96704 9.84333 4.99829 12.2079 4.99829 14.9996C4.99829 17.7912 5.96704 20.1558 7.90454 22.0933C9.84204 24.0308 12.2066 24.9996 14.9983 24.9996C17.79 24.9996 20.1545 24.0308 22.092 22.0933C24.0295 20.1558 24.9983 17.7912 24.9983 14.9996C24.9983 12.2079 24.0295 9.84333 22.092 7.90583C20.1545 5.96833 17.79 4.99958 14.9983 4.99958Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleLeft);
export default __webpack_public_path__ + "static/media/arrow_circle_left.c11ec044b71b85d7a6a60ecb7a3049eb.svg";
export { ForwardRef as ReactComponent };